import * as Yup from "yup";

const formField = {
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "text",
    errorMsg: "Warehouse code is required.",
    required: true,
    editable: false,
    maxLength: 20,
  },
  descriptions1: {
    name: "descriptions1",
    label: "Descriptions 1",
    type: "text",
    errorMsg: "Descriptions 1 is required.",
    required: true,
    maxLength: 100,
  },
  descriptions2: {
    name: "descriptions2",
    label: "Descriptions 2",
    type: "text",
    maxLength: 100,
  },
};
export const form = {
  formId: "new-warehouse-form",
  formField,
};

const { warehouseCode, descriptions1, descriptions2 } = formField;

export const formRender=[
  [warehouseCode],[descriptions1],[descriptions2]
]

export const initialValues = {
  [warehouseCode.name]: null,
  [descriptions1.name]: null,
  [descriptions2.name]: null,
};

export const warehouseValidations = Yup.object().shape({
  [warehouseCode.name]: Yup.string().max(20).required(warehouseCode.errorMsg),
  [descriptions1.name]: Yup.string().max(100).required(descriptions1.errorMsg),
  [descriptions2.name]: Yup.string().max(100).nullable(),
});
